import template from './procedure-list.html';
import controller from './procedure-list.controller';

let procedureListComponent = {
  bindings: {},
  template,
  controller
};

export default procedureListComponent;



// WEBPACK FOOTER //
// ./client/app/components/procedure/procedure-list.component.js